import * as SplashScreen from 'expo-splash-screen';

const TAG = '[SplashScreenService] ->';

class SplashScreenService {
	public constructor() {
		console.info(TAG, 'init()');
	}

	async preventAutoHide() {
		await SplashScreen.preventAutoHideAsync();
	}

	async hideAsync() {
		await SplashScreen.hideAsync();
	}
}

export default new SplashScreenService();
